<template>
  <div>
    <Header />
    <div class="banner">
      <div class="banner_title">{{ $t("header.technology") }}</div>
    </div>
    <div class="technology-box">
      <div class="container">
        <div class="title">{{ $t("home.hunningtu") }}</div>
        <div class="technology-item section1">
          <div class="row">
            <div class="col-md-5 d-none d-md-block">
              <img
                src="../assets/image/technology-2.png"
                class="img-fluid"
                alt=""
              />
              <p style="margin-bottom: 29px">{{ $t("home.tech_2") }}</p>
            </div>
            <div class="col-md-6 offset-md-1 col-12 item-con-box">
              <div class="item-con">
                <div class="item-title">
                  <img
                    src="../assets/image/technology-1.png"
                    class="img-fluid"
                    alt="img"
                  />
                  <span>{{ $t("home.tech_1") }}</span>
                </div>
                <p>
                  {{ $t("technology.tec1_txt") }}
                </p>
              </div>
            </div>
          </div>
          <div class="bottom-box">
            <div class="bottom-img d-md-none d-block">
              <img
                src="../assets/image/technology-2.png"
                class="img-fluid"
                alt=""
              />
              <p>{{ $t("home.tech_2") }}</p>
            </div>
            <div class="bottom-img">
              <img
                src="../assets/image/technology-3.png"
                class="img-fluid"
                alt=""
              />
              <p>{{ $t("equipment.equip1") }}</p>
            </div>
            <div class="bottom-img">
              <img
                src="../assets/image/technology-4.png"
                class="img-fluid"
                alt=""
              />
              <p>{{ $t("technology.tec18_txt") }}</p>
            </div>
            <div class="bottom-img">
              <img
                src="../assets/image/technology-5.png"
                class="img-fluid"
                alt=""
              />
              <p>{{ $t("equipment.equip7") }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="technology-item section2">
        <div class="container">
          <div class="row">
            <div class="col-md-6 col-12 section2-part2">
              <div class="item-con">
                <div class="item-title">
                  <img src="../assets/image/technology-6.png" alt="img" />
                  <span>{{ $t("home.tech_3") }}</span>
                </div>
                <p>
                  {{ $t("technology.tec2_txt") }}
                </p>
              </div>

              <div class="d-md-block d-none">
                <div class="part2-box">
                  <div class="part2-img-box">
                    <img
                      src="../assets/image/technology-9.png"
                      class="img-fluid"
                      alt=""
                    />
                    <p>{{ $t("equipment.equip8") }}</p>
                  </div>

                  <div class="part2-img-box">
                    <img
                      src="../assets/image/technology-10.png"
                      class="img-fluid"
                      alt=""
                    />
                    <p>{{ $t("equipment.equip3") }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-12 section2-part1">
              <div class="item-con">
                <div class="item-title">
                  <img src="../assets/image/technology-6.png" alt="img" />
                  <span>{{ $t("home.tech_3") }}</span>
                </div>
                <p>
                  {{ $t("technology.tec2_txt") }}
                </p>
              </div>
              <div class="part2-box">
                <div class="part2-img-box">
                  <img
                    src="../assets/image/technology-7.png"
                    class="img-fluid d-none d-md-block"
                    alt=""
                  />
                  <img
                    src="../assets/image/technology-21.png"
                    class="img-fluid d-md-none d-block"
                    alt=""
                  />
                  <p style="text-align: center">
                    {{ $t("equipment.equip5") }}
                  </p>
                </div>
                <div class="part2-img-box">
                  <img
                    src="../assets/image/technology-8.png"
                    class="img-fluid d-none d-md-block"
                    alt=""
                  />
                  <img
                    src="../assets/image/technology-22.png"
                    class="img-fluid d-md-none d-block"
                    alt=""
                  />
                  <p style="text-align: center">{{ $t("equipment.equip5") }}</p>
                </div>
              </div>

              <p class="section2-txt">
                {{ $t("technology.tec3_txt") }}
              </p>
              <div class="d-md-none d-block">
                <div class="part2-box">
                  <div class="part2-img-box">
                    <img
                      src="../assets/image/technology-9.png"
                      class="img-fluid d-none d-md-block"
                      alt=""
                    />
                    <img
                      src="../assets/image/technology-24.png"
                      class="img-fluid d-md-none d-block"
                      alt=""
                    />
                    <p>{{ $t("equipment.equip8") }}</p>
                  </div>

                  <div class="part2-img-box">
                    <img
                      src="../assets/image/technology-10.png"
                      class="img-fluid d-none d-md-block"
                      alt=""
                    />
                    <img
                      src="../assets/image/technology-23.png"
                      class="img-fluid d-md-none d-block"
                      alt=""
                    />
                    <p>{{ $t("equipment.equip3") }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="technology-item section3">
        <div class="container">
          <div class="row">
            <div class="col-md-6 col-12 section2-part1">
              <div class="item-con">
                <div class="item-title">
                  <img src="../assets/image/technology-11.png" alt="img" />
                  <span>{{ $t("home.tech_5") }}</span>
                </div>
                <p>
                  {{ $t("technology.tec4_txt") }}
                </p>
              </div>
              <div class="part2-box">
                <div class="part2-img-box">
                  <img
                    src="../assets/image/technology-12.png"
                    class="img-fluid"
                    alt=""
                  />
                  <p>{{ $t("technology.tec9_txt") }}</p>
                </div>
                <div class="part2-img-box">
                  <img
                    src="../assets/image/technology-13.png"
                    class="img-fluid"
                    alt=""
                  />
                  <p>{{ $t("technology.tec10_txt") }}</p>
                </div>
              </div>

              <p class="section3-txt">
                {{ $t("technology.tec5_txt") }}
              </p>
            </div>
            <div class="col-md-6 col-12 section2-part2">
              <div class="item-con">
                <div class="item-title">
                  <img src="../assets/image/technology-11.png" alt="img" />
                  <span>{{ $t("home.tech_5") }}</span>
                </div>
                <p>
                  {{ $t("technology.tec4_txt") }}
                </p>
              </div>

              <div class="part2-box">
                <div class="part2-img-box">
                  <img
                    src="../assets/image/technology-14.png"
                    class="img-fluid"
                    alt=""
                  />
                  <p>{{ $t("technology.tec11_txt") }}</p>
                </div>

                <div class="part2-img-box">
                  <img
                    src="../assets/image/technology-15.png"
                    class="img-fluid"
                    alt=""
                  />
                  <p>{{ $t("technology.tec12_txt") }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="technology-item section4">
        <div class="container">
          <div class="row">
            <div class="col-md-6 col-12 section2-part2 pr0">
              <div class="item-con">
                <div class="item-title">
                  <img src="../assets/image/technology-16.png" alt="img" />
                  <span>{{ $t("home.tech_7") }}</span>
                </div>
                <p>
                  {{ $t("technology.tec6_txt") }}
                </p>
                <p>
                  {{ $t("technology.tec8_txt") }}
                </p>
              </div>
              <div class="section2-box d-none d-md-block">
                <div class="section2-item-top">
                  <img
                    src="../assets/image/technology-18.png"
                    class="img-fluid"
                    alt=""
                  />
                  <p>{{ $t("technology.tec15_txt") }}</p>
                </div>
                <div class="section2-item-bottom">
                  <div class="item1">
                    <img
                      src="../assets/image/technology-19.png"
                      class="img-fluid"
                      alt=""
                    />
                    <p>{{ $t("technology.tec16_txt") }}</p>
                  </div>
                  <div class="item1">
                    <img
                      src="../assets/image/technology-20.png"
                      class="img-fluid"
                      alt=""
                    />
                    <p>{{ $t("technology.tec17_txt") }}</p>
                  </div>
                </div>
                <p class="section4-txt-sj">
                  {{ $t("technology.tec7_txt") }}
                </p>
              </div>
            </div>
            <div class="col-md-6 col-12 section2-part1 pl0">
              <div class="item-con">
                <div class="item-title">
                  <img src="../assets/image/technology-16.png" alt="img" />
                  <span>{{ $t("home.tech_7") }}</span>
                </div>
                <p>
                  {{ $t("technology.tec6_txt") }}
                </p>
              </div>
              <div class="col-12">
                <img
                  src="../assets/image/technology-17.png"
                  class="img-fluid"
                  alt=""
                />
                <div class="section4-p">
                  <p>{{ $t("technology.tec13_txt") }}</p>
                  <p>{{ $t("technology.tec14_txt") }}</p>
                </div>
                <p class="item2 d-none d-md-block">
                  {{ $t("technology.tec7_txt") }}
                </p>
              </div>
              <p class="section4-txt-sj">
                {{ $t("technology.tec8_txt") }}
              </p>
              <div class="section2-box d-block d-md-none">
                <div class="section2-item-top">
                  <img
                    src="../assets/image/technology-18.png"
                    class="img-fluid"
                    alt=""
                  />
                  <p>{{ $t("technology.tec15_txt") }}</p>
                </div>
                <div class="section2-item-bottom">
                  <div class="item1">
                    <img
                      src="../assets/image/technology-19.png"
                      class="img-fluid"
                      alt=""
                    />
                    <p>{{ $t("technology.tec16_txt") }}</p>
                  </div>
                  <div class="item1">
                    <img
                      src="../assets/image/technology-20.png"
                      class="img-fluid"
                      alt=""
                    />
                    <p>{{ $t("technology.tec17_txt") }}</p>
                  </div>
                </div>
                <p class="section4-txt-sj">
                  {{ $t("technology.tec7_txt") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="less" scoped>
.banner {
  background: url("../assets/image/technology-banner.png") no-repeat;
  background-position: center;
  background-size: cover;
  height: 500px;
  position: relative;
  top: 140px;
  margin-bottom: 140px;
  width: 100%;
}
.banner_title {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-size: 60px;
  font-family: PingFang SC;
  font-style: italic;
  color: #ffffff;
  text-align: center;
}
.title {
  background: url("../assets/image/home-skill-1.png") no-repeat;
  background-position: center;
  background-size: contain;
  font-size: 30px;
  font-weight: 800;
  font-style: italic;
  color: #054ea4;
  text-align: center;
  margin: 100px 0;
}
.item-con-box {
  align-items: center;
  justify-content: center;
  display: flex;
}
.bottom-box {
  display: flex;
  justify-content: space-between;
  .bottom-img {
    width: 32%;
    p {
      font-weight: bold;
    }
  }
}
.technology-box {
  overflow: hidden;
  .technology-item {
    margin-bottom: 50px;
    img {
      margin-bottom: 10px;
    }
    p {
      font-size: 14px;
      text-align: center;
      color: #333333;
    }
    .item-con {
      width: 100%;
      .item-title {
        white-space: nowrap;
        span {
          display: inline-block;
          vertical-align: bottom;
          margin-left: -32px;
          font-size: 20px;
          font-weight: bold;
          color: #333333;
        }
      }
      p {
        padding: 20px 20px 0 50px;
        font-size: 14px;
        color: #333333;
        text-align: left;
        margin-bottom: 0;
        line-height: 26px;
        text-indent: 2em;
      }
    }
  }
}

.section2,
.section4 {
  background: #f5f5f5;
  padding: 100px 0;
}

.section2-part2 {
  padding-right: 35px;
  .item-con {
    margin-bottom: 120px;
  }
}
.part2-box {
  display: flex;
  .part2-img-box {
    width: 50%;
    p {
      text-align: center;
      font-weight: bold;
    }
    &:nth-child(1) {
      margin-right: 5px;
    }
    img {
      width: 100%;
    }
  }
}
.section2 .section2-txt {
  width: 321px;
  text-align: left !important;
  margin-left: -47px;
  margin-top: 85px;
  text-indent: 1.5rem;
}

.technology-box .section3 {
  margin-bottom: 100px;
  padding-top: 50px;
  .item-con {
    margin: 94px 0 64px 0;
  }
  .section3-txt {
    width: 356px;
    margin-left: 34%;
    margin-top: 50px;
    text-indent: 1.5rem;
  }
}

.section2-box {

  .section2-item-bottom {
    display: flex;
    align-items: center;
    .item1 {
      margin-right: 20px;
      p {
        font-weight: bold;
      }
    }
  }
}

.section4 {
  margin-bottom: 0 !important;
  .item2 {
    width: 315px;
    text-align: left !important;
    transform: translateX(-13%);
    margin-top: 106px;
  }
  .item-con {
    margin-bottom: 74px;
  }
}
.section4-p {
  display: flex;
  p {
    width: 50%;
    text-align: center;
    font-weight: bold;
  }
}
.section2-part1 {
  padding-left: 35px;
}
.section2 .section2-part1 .item-con,
.section3 .section2-part1 .item-con,
.section4 .section2-part1 .item-con {
  display: none;
}
.section4-txt-sj {
  display: none;
}
.section2-item-top {

  p {
    width: 90%;
    font-weight: bold;
  }
}
@media (min-width: 1200px) {

  .section2 .section2-part1 .item-con,
  .section3 .section2-part1 .item-con,
  .section4 .section2-part1 .item-con {
    display: none;
  }
  .section4-txt-sj {
    display: none;
  }
  .section2-item-top {
    margin-bottom: 20px;
    p {
      width: 90%;
      font-weight: bold;
    }
  }
  .section2-box {
    padding-left: 44px;

        .section2-item-bottom {
          display: flex;
          align-items: center;
          .item1 {
            margin-right: 20px;
            p {
              font-weight: bold;
            }
          }
        }
  }
  .technology-box .section3 .section3-txt {
    margin-left: 20%;
    margin-top: 90px;
  }
  .section4 .item2 {
    transform: translateX(0%);
    margin-top: 162px;

  }
}
@media (max-width: 1200px) and (min-width: 1024px) {
  .technology-box .section3 .section3-txt {
    margin-left: 20%;
    margin-top: 90px;
  }
  .section4 .item2 {
    transform: translateX(0%);
    margin-top: 162px;

  }
}

@media (max-width: 1024px) and (min-width: 769px) {
  .banner {
    top: 75px;
    margin-bottom: 75px;
    height: 270px;
    background-size: 100%;
  }
  .title {
    margin: 50px 0 22px 0;
    font-size: 19px;
  }
  .technology-box .technology-item {
    margin-bottom: 30px;
  }
  .technology-box .technology-item p {
    font-size: 10px;
  }
  .section2,
  .section4 {
    padding: 50px 0;
  }
  .section3-txt {
    margin-left: 24%;
    text-align: left !important;
  }
  .section2-txt {
    width: 250px;
    margin-top: 56px;
  }
  .section3-txt {
    width: 260px;
    margin-left: 30%;
  }
  .section2-box {
    padding-right: 50px;
    padding-left: 50px;
}
  .item2 {
    width: 240px;
    text-align: left !important;
    transform: translateX(-28%);
    margin-top: 115px;
  }
  .item-title {
    img {
      height: 37px;
    }
    span {
      font-size: 16px !important;
    }
  }
  .news-section {
    padding: 0;
  }
  .news-section .news-list a {
    margin: 10px 0;
  }
  .technology-box .section3 {
    .section3-txt {
      margin-left: 24%;
    }
  }
  .section2 {
    .item-con {
      margin-bottom: 33px;
    }
    .section2-txt {
      margin-top: 56px;
      width: 210px;
    }
  }
  .section1 {
    .item-con {
      p {
        padding: 0px 20px 0 15px !important;
      }
    }
  }
  .technology-box .section3 {
    .item-con {
      margin: 12px 0 24px 0 !important;
    }
    .section3-txt {
      margin-left: 39%;
      width: 204px;
      margin-top: 44px;
    }
  }
  .technology-box .section4 {
    .item-con {
      margin-bottom: 26px;
      p {
        padding: 13px 0px 0 20px;
      }
    }
  }
  .section4 .item2 {
    width: 216px;
    transform: translateX(-20%);
    margin-top: 50px;
  }
}
@media (max-width: 992px) and (min-width: 768px) {
  .banner {
    height: 205px;
  }
  .section4 .item2 {
    margin-top: 100px;
    padding-left: 30px;
  }
}

@media (max-width: 767px) and (min-width: 320px) {
  .banner {
    background-image: url("../assets/image/WechatIMG495.jpeg");
    background-size: cover;
    top: 50px;
    margin-bottom: 0px;
    height: 230px;
    .banner_title {
      display: block;
      font-size: 25px;
    }
  }
  .title {
    margin-bottom: 25px;
    font-size: 18px;
  }
  .section2-part1 p {
    padding-left: 0;
  }
  .section4 .section2-part1 p {
    margin-right: 0;
  }
  .section1-part2 {
    padding: 0 30px;
  }
  .section2,
  .section4 {
    background: #ffffff;
    padding: 10px 0;
  }
  .section2 .section2-part1 .item-con,
  .section3 .section2-part1 .item-con,
  .section4 .section2-part1 .item-con {
    display: block;
    p {
      padding: 10px;
      margin-top: 0;
    }
  }
  .section2-part2 .item-con {
    display: none;
  }
  .section2-part1 p {
    margin-top: 10px;
  }
  .section4-txt-sj {
    display: block;
    padding-left: 20px;
  }
  .section4-txt-p {
    display: none;
  }
  .section4-sj-img {
    margin: 0 auto;
  }
  .part2-box {
    .part2-img-box {
      padding: 0 2px;
    }
  }
  .item-title {
    img {
      height: 35px;
    }
    span {
      font-size: 14px !important;
    }
  }
  .technology-box .technology-item .item-con p {
    font-size: 12px;
    padding: 14px 0 15px 22px;
  }
  .technology-box .technology-item img {
    margin-bottom: 0;
  }
  .bottom-box {
    flex-wrap: wrap;
    .bottom-img {
      width: 49%;
      margin: 0px 1px 10px 0;
      // margin-right: 3px;

      img {
        height: 128px;
        width: 100%;
      }
      p {
        font-size: 10px;
      }
    }
  }
  .part2-box {
    display: flex;
    padding: 0 33px;
  }
  .section2 .section2-txt {
    width: 90%;
    margin-left: 22px;
    margin-top: 0;
    font-size: 12px !important;
  }
  .part2-box .part2-img-box p {
    font-size: 10px;
  }
  .technology-box .technology-item {
    margin-bottom: 25px;
  }
  .technology-box .section3 .section3-txt {
    width: 90%;
    margin-left: 22px;
    font-size: 12px !important;
    margin-top: 0;
  }
  .technology-box .section3 {
    padding: 0;
  }
  .section4-txt-sj {
    font-size: 12px !important;
    padding: 0 20px !important;
    text-align: left !important;
  }
  .section2-item-top {
    padding: 0 50px;
    p {
      font-size: 11px !important;
    }
  }
  .section2-item-bottom {
    padding: 0 44px;
    p {
      font-size: 11px !important;
    }
    .item1 {
      margin-right: 8px !important;
    }
  }
  .section4-p {
    p {
      font-size: 11px !important;
      margin-top: 5px;
    }
  }
  .section2-part1 {
    padding-left: 15px !important;
  }
  .section2-part2 {
    padding-right: 15px;
  }
  .technology-box .section3 .item-con {
    margin: 0;
  }
  .section4 .item-con {
    margin-bottom: 0;
  }
  .technology-box .technology-item .item-con p {
    line-height: 20px;
  }
  .section2-box[data-v-5899393c] {
    padding-left: 0;
  }
  .part2-img-box p {
    text-align: center !important;
    margin-top: 5px;
  }
  .section2-part1 p {
    margin-top: 5px;
  }
}
</style>
